
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/jet-club",
      function () {
        return require("private-next-pages/dashboard/jet-club/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/jet-club"])
      });
    }
  